import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { ReceiptDetail, ReceiptOrder } from "../../../models/receipt.model";
import Shop from "../../../models/shop.model";
import {
  InvalidFormatError,
  InvalidNumberError,
  NotEnoughUnitError,
  ReadingConfig,
  doReadNumber,
} from "read-vietnamese-number";

@Component({
  selector: "ngx-dialog-print-receipt-order",
  templateUrl: "dialog-print-receipt-order.component.html",
  styleUrls: ["dialog-print-receipt-order.component.scss"],
})
export class DialogPrintReceiptOrderComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() user?: User;
  @Input() shop?: Shop;
  @Input() receipt?: ReceiptOrder;
  @Input() totalQuantity = 0;
  @Input() receiptDetails?: ReceiptDetail[] = [];

  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;

  loading = false;
  printing = false;
  displayName = "";

  currentDate: Date = new Date();

  totalAmountText?: string = "";
  config = new ReadingConfig();

  constructor(
    protected ref: NbDialogRef<DialogPrintReceiptOrderComponent>,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });

    this.config.unit = ["đồng"];

    try {
      // Start reading
      this.totalAmountText = doReadNumber(
        this.config,
        this.receipt.totalAmount.toFixed(0),
      );
    } catch (err) {
      // Handle errors
      if (err instanceof InvalidFormatError) {
        console.error("Định dạng input không hợp lệ");
      } else if (err instanceof InvalidNumberError) {
        console.error("Số không hợp lệ");
      } else if (err instanceof NotEnoughUnitError) {
        console.error("Không đủ đơn vị đọc số");
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // this.print();
    }, 1000);
  }

  cancel() {
    this.ref.close();
  }

  print() {
    this.printing = true;
    let el: HTMLElement = this.printBtn.nativeElement;
    el.click();
    this.ref.close(true);
  }
}
